import type { RouteRecordRaw } from "vue-router";

const ordersRoutes: RouteRecordRaw[] = [
  {
    path: "/orders/create",
    name: "create-order",
    component: () => import("@/views/Orders/ViewCreateOrder.vue"),
    meta: {
      title: "Create an Order",
      requiresAuth: true,
      ordersPermission: "createOrder",
    },
  },
  {
    path: "/orders/view",
    name: "view-orders",
    component: () => import("@/views/Orders/ViewOrders.vue"),
    meta: {
      title: "View Orders",
      requiresAuth: true,
      ordersPermission: "viewOrders",
    },
  },
];

export default ordersRoutes;
